import { render, staticRenderFns } from "./SetRule.vue?vue&type=template&id=7c8e5d54&scoped=true"
import script from "./SetRule.vue?vue&type=script&lang=js"
export * from "./SetRule.vue?vue&type=script&lang=js"
import style0 from "./SetRule.vue?vue&type=style&index=0&id=7c8e5d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e5d54",
  null
  
)

export default component.exports